import React, { useEffect } from "react";
import { useTheme, withStyles } from "@material-ui/core/styles";
import "fontsource-muli";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import CustomModal from "../../../components/CustomModal";
import Color from "../../../../utils/Color";
import Grid from "@material-ui/core/Grid";

const TermsAndConditions = ({
  classes,
  isVisible,
  onClickAgree,
  onClickDisagree,
  onClickImportantNotice,
  handleClose,
}) => {
  const modalContainer = () => {
    return (
      <div className={classes.containerStyle}>
        <CustomText design={classes.titleTextStyle}>
          eGIRO Terms & Conditions
        </CustomText>
        <Grid
          container
          direction={"column"}
          spacing={1}
          style={{ paddingLeft: "5%", paddingRight: "10%" }}
        >
          <Grid item>
            <div className={classes.p}>
              <CustomText design={classes.bulletStyle}>•</CustomText>
              <CustomText design={classes.noteTextStyle}>
                I / We hereby instruct you to process Etiqa Insurance Pte. Ltd.(Etiqa) instructions to debit my / our account below as
                instructed and / or to debit such sum(s) as Etiqa may notify you
                from time to time.
              </CustomText>
            </div>
            <div className={classes.p}>
              <CustomText design={classes.bulletStyle}>•</CustomText>
              <CustomText design={classes.noteTextStyle}>
                You are entitled to reject Etiqa’s debit instructions if my /
                our account does not have sufficient funds and charge me / us a
                fee for this. You may also at your discretion allow the debit
                even if this results in an overdraft on the account and impose
                charges accordingly.
              </CustomText>
            </div>
            <div className={classes.p}>
              <CustomText design={classes.bulletStyle}>•</CustomText>
              <CustomText design={classes.noteTextStyle}>
                Should payment not be successfully effected pursuant to this
                authorisation for any reason, Etiqa shall under no circumstances
                be responsible or be held liable for any losses or claims of
                whatsoever nature arising out of any delay or failure to process
                this transaction, or any subsequent expiry of the policies due
                to late or non-payment of premiums
              </CustomText>
            </div>
            <div className={classes.p}>
              <CustomText design={classes.bulletStyle}>•</CustomText>
              <CustomText design={classes.noteTextStyle}>
                This authorization will remain in force until revoked by me/us
                by written notice delivered to you or upon your receipt of
                my/our written revocation through Etiqa. You may in your
                absolute discretion terminate this arrangement by written notice
                to me/us delivered to my/our last known recorded address.
              </CustomText>
            </div>
            <div className={classes.p}>
              <CustomText design={classes.bulletStyle}>•</CustomText>
              <CustomText design={classes.noteTextStyle}>
                By providing the information in this application form and
                submitting this application, I further request for and consent
                to the collection, use and disclosure of my personal data by
                Etiqa and its related corporations, its agents and Etiqa sharing
                such personal data with Etiqa’s business partners, marketing
                partners and the Co-Brand Partner (as may be relevant), as well
                as their authorised service provider, for the purpose of this
                form.
              </CustomText>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <div>
      <CustomModal
        open={isVisible}
        handleClose={handleClose}
        titlestyle={classes.modalTitleStyle}
        modalDesign={classes.modalDesign}
        isVisibleCloseButton={true}
        //submitButtonText={"I Agree"}
        //cancelButtonText={"I Disagree"}
        modalComponent={modalContainer()}
        disableBackdropClick
        handleSubmitButton={onClickAgree}
        handleCancelButton={onClickDisagree}
      />
    </div>
  );
};

const styles = (theme) => ({
  containerStyle: {
    flexGrow: 1,
    marginBottom: 30,
    paddingRight: 20,
  },
  modalTitleStyle: {
    ...getFontSize("large"),
  },
  titleTextStyle: {
    ...getFontSize("large"),
    ...getFontWeight("bold"),
    marginBottom: 20,
    textAlign: "center",
    fontFamily:"Muli",
    fontSize:"28px"
  },
  descTitleTextStyle: {
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  descTextStyle: {
    ...getFontSize("small"),
    lineHeight: 1.4,
    marginBottom: 5,
  },
  modalDesign: {
    width: "750px",
    textInputStyle: {
      height: 35,
      marginLeft: 5,
      marginRight: 5,
    },
  },
  tooltipContainer: {
    display: "flex",
    alignItems: "center",
  },
  infoIconStyle: {
    width: "17px",
    height: "17px",
    alignSelf: "center",
    color: Color.secondaryTextColor,
    marginLeft: 10,
  },
  tooltipTextStyle: {
    color: Color.secondaryTextColor,
    ...getFontWeight("normal"),
  },
  highLightedTextStyle: {
    color: Color.primaryColor,
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  textInputContainer: {
    height: 40,
    marginLeft: 10,
  },
  dividerStyle: {
    marginTop: 20,
    marginBottom: 20,
  },
  paymentInputContainer: {
    height: 40,
    [theme.breakpoints.only("xs")]: {
      width: 150,
    },
    width: 300,
  },
  paymentInputTitleTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("small"),
    marginBottom: 2,
    color: Color.primaryTextColor,
  },
  p: {
    position: "relative",
    //margin: "20px",
    marginLeft: "10%",
    marginBottom: "2%",
  },
  bulletStyle: {
    position: "absolute",
    left: "-40px",
    top: "10%",
    transform: "translate(0%,-50%)",
    fontWeight: "bold",
  },
  noteTextStyle:{
      fontFamily:"Muli",
      fontSize:"16px",
      fontWeight:"400",
      color:"#424143"
  }
});

export default withStyles(styles, { withTheme: true })(TermsAndConditions);
